<template>
    <div class="table-responsive" style="overflow: hidden;">
        <div class=" table mb-0 col-xs-12 p-0">
          <table class="w-100">
            <tbody>
              <tr>
                <td class="d-flex align-items-center p-0 mb-2" style=";border: none !important;">
                  <p class="mb-0 col-md-7 pl-0 pr-2 text-nowrap" style="color: #fc6075;" title="Talent Search - HR Management">Application Management - HR Management</p>
                  <strong class="col-md-5 pr-0 pl-2 text-nowrap" title="Completed in 3 Years">Active</strong>
                </td>
              </tr>
              <tr>
                <td class="d-flex align-items-center p-0 mb-2" style=";border: none !important;">
                  <p class="mb-0 col-md-7 pl-0 pr-2 text-nowrap" style="color: #fc6075;" title="Set Search Criteria Stage">2: Medical Test</p>
                  <strong class="col-md-7 pr-0 pl-2">{{app.status > 6 ? 'Completed' : (app.status == 6) ?'Active' : 'Inactive'}}</strong>
                </td>
              </tr>
              <tr>
                <td class="d-flex align-items-center p-0 mb-2">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="la la-check"></i>Result</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                    <select class="form-control" v-model="app.applicationMedical.result">
                      <option selected>No Yet</option>
                      <option :value="1">Passed</option>
                      <option :value="2">Failed</option>
                    </select></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button v-if="(app.status == 6)" type="button" class="btn btn-primary btn-lg btn-block mt-5" style="border-radius: 0" @click="action">Complete Stage <i class="la la-angle-right ml-2"></i></button>
    </div>
</template>

<script>
export default {
  name: "applications-timeline-seven",
  props: {
    action: { type: Function },
         app: {},
         currentOffice: {}
      },
  data() {
    return {
      searchFinished: true,
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/applications/applications-timeline-seven.vue